import React from 'react';

type FieldConfigStyleTypeSectionProps = {
    id?: string;
    fieldTypeName: string;
}

export const FieldConfigStyleTypeSection: React.FC<FieldConfigStyleTypeSectionProps> = ({
    id,
    fieldTypeName
}) => {
    const baseId = id || 'field-config-style-type-section';

    return (
        <div id={baseId} data-testid={baseId} className="tw-mb-6">
            <div id={`${baseId}-label`} className="tw-text-[#747593] tw-text-sm tw-mb-2">Style Type</div>
            <span id={`${baseId}-value`} className="tw-text-[#172B4D]">{fieldTypeName}</span>
        </div>
    );
};
